"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * As interfaces are compile time only, there's no way to test for "instanceof Interface" during runtime.
 * TypeGuard provides logic to detect if an object implements a specific function of that interface.
 */
class TypeGuard {
    static isLoadable(obj) {
        return obj.load !== undefined;
    }
    static isDOMInsertable(obj) {
        return obj.insertInto !== undefined;
    }
    static isBlurrable(obj) {
        return obj !== null && obj.blur !== undefined;
    }
    static isResponse(obj) {
        return 'json' in obj && 'ok' in obj;
    }
    static isPromise(obj) {
        var _a;
        return ((_a = obj === null || obj === void 0 ? void 0 : obj.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'Promise';
    }
    static isMountable(obj) {
        return typeof obj === 'object' && obj !== null && 'mount' in obj;
    }
    static isHTMLInputElement(obj) {
        return obj instanceof HTMLElement && 'value' in obj && 'type' in obj && 'disabled' in obj;
    }
    static isNumber(obj) {
        return typeof obj === 'number' && isNaN(obj) === false && isFinite(obj);
    }
    static isString(obj) {
        return typeof obj === 'string';
    }
    static isBoolean(obj) {
        return typeof obj === 'boolean';
    }
    static isObject(obj) {
        return typeof obj === 'object' && obj !== null && Array.isArray(obj) === false;
    }
    static isArray(obj) {
        return Array.isArray(obj);
    }
    static isNull(obj) {
        return obj === null;
    }
}
exports.default = TypeGuard;
//# sourceMappingURL=TypeGuard.js.map